import React from 'react';
import { Aux } from '../../../hoc/Aux';
import Item from '../../../Components/Item/Item';
class ListOutput extends React.Component{
    state={
        visibleItemArray:[]
    }

    componentWillUpdate(nextProps ,nextState){
        console.log("componentWillUpdate");
        if(nextProps.itemArray!==this.props.itemArray)
         this.setState({visibleItemArray : nextProps.itemArray})
    }

    
    render(){

       // this.updateState();

    
       return ( 
            <Aux>
                <h3>Output List</h3>
                <table className='table'>
                    <tbody>
                        <tr>
                            <th>ID</th>
                            <th>NAME</th>
                            <th>IMG</th>
                            <th>OPERATIONS</th>
                        </tr>

                    </tbody>
                    <tbody>
                    {
                        this.state.visibleItemArray.map(
                            item => {
                                console.log(item,item.id);
                               return <Item itemObject={item} key={item.id} />
                            }
                        )
                    }
                    </tbody>
                </table>
            </Aux>
       );

    }
}
export default ListOutput;


// WEBPACK FOOTER //
// ./src/Containers/OutputDetails/ListOutput/ListOutput.js